export default __webpack_public_path__ + "static/media/background.419c79e1.jpg";